export const header = (
  <a href="https://www.saobernardo.sp.gov.br/web/imasf" target="_blank" rel="noreferrer noopened">
    <div
      className="sc-iqHYGH ieNPiA rsc-header"
      style={{
        background: '#ffff',
        height: '53px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 10px',
      }}
    >
      <img
        src="/8/imasf.png"
        alt="imasf"
        style={{
          width: '110px',
        }}
      />
      <img src="/8/prefeitura.png" alt="prefeitura são bernardo" style={{ width: '110px' }} />
    </div>
  </a>
);
